export const CHART_MODULE = {
  BI: 1,
  COMMU: 2,
  ANALYTICS: 3,
};
